import { SegmentDefinition } from '../utils/urlResolver';
import axios from '.';

export const getSegmentDefinition = (params) => {
  return axios({
    method: 'GET',
    url: SegmentDefinition.listing,
    params,
  });
};

export const getSegmentDefinitionData = (params) => {
  return axios({
    method: 'GET',
    url: SegmentDefinition.data,
    params,
  });
};

export const addSegmentDefinition = (data) => {
  return axios({
    method: 'POST',
    url: SegmentDefinition.add,
    data,
  });
};

export const addSegmentValue = (data) => {
  return axios({
    method: 'POST',
    url: SegmentDefinition.createData,
    data,
  });
};

export const editSegmentDefinition = (data) => {
  return axios({
    method: 'PUT',
    url: SegmentDefinition.edit,
    data,
  });
};

export const editSegmentDataDefinition = (data) => {
  return axios({
    method: 'PUT',
    url: SegmentDefinition.editData,
    data,
  });
};

export const getTotalSegmentValues = (params) => {
  return axios({
    method: 'GET',
    url: SegmentDefinition.dataCount,
    params,
  });
};
